import React, { useMemo } from 'react';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';
import { IEntityInfoView } from '@components/widgets/entity-info/EntityInfoFields';
import EntityInfoWidget from '@components/widgets/entity-info/EntityInfoWidget';
import { IAbstractRecord } from '@models';
import { CDN_URL } from '@utils';
import { MAIN_THEME } from '@styles';

interface ICoverEntityInfoWidgetProps {
  data: IAbstractRecord;
  handleIconClick: () => void;
}

const CoverEntityInfoWidget: React.FC<ICoverEntityInfoWidgetProps> = ({
  data,
  handleIconClick,
}) => {
  const entityView = useMemo(() => {
    const result: IEntityInfoView = {
      name: 'section1',
      title: 'Policy Cover Details',
      iconUrl: '',
      sections: [
        {
          name: 'policyCoverDetailsSection1',
          title: '',
          properties: {
            lineName: {
              value: data?.lineName,
              multiline: false,
              name: 'lineName',
              title: 'Line',
              type: EnhancedDisplayType.RelativeLink,
              tooltip: false,
              url: '/plan/lines/' + data?.lineId,
            },
            externalCode: {
              value: data?.externalCode,
              multiline: false,
              name: 'externalCode',
              title: 'External Code',
            },
            arabicName: {
              value: data?.arabicName,
              multiline: false,
              name: 'arabicName',
              title: 'Arabic Name',
            },
            printingOrder: {
              value: data?.printingOrder,
              multiline: false,
              name: 'printingOrder',
              title: 'Printing Order',
            },
            policyCoverDescription: {
              value: data?.policyCoverDescription,
              multiline: false,
              name: 'policyCoverDescription',
              title: 'Description',
            },
            policyCoverTreatyID: {
              value: data?.policyCoverTreatyID,
              multiline: false,
              name: 'policyCoverTreatyID',
              title: 'Treaty',
            },
          },
        },
        {
          name: 'policyCoverDetailsSection2',
          title: '',
          properties: {
            createdBy: {
              value: data?.createdBy,
              multiline: false,
              name: 'createdBy',
              title: 'Created By',
            },
            createdOn: {
              value: data?.createdOn,
              multiline: false,
              type: EnhancedDisplayType.DateTime,
              name: 'createdOn',
              title: 'Created On',
            },
            modifiedBy: {
              value: data?.modifiedBy,
              multiline: false,
              name: 'modifiedBy',
              title: 'Modified By',
            },
            modifiedOn: {
              value: data?.modifiedOn,
              multiline: false,
              type: EnhancedDisplayType.DateTime,
              name: 'modifiedOn',
              title: 'Modified On',
            },
          },
        },
      ],
      socialMedia: {
        facebook: '',
        linkedIn: '',
        twitter: '',
      },
    };

    return result;
  }, [data]);

  return (
    <EntityInfoWidget
      background={MAIN_THEME.color.red}
      classification={{ classifications: {}, value: '' }}
      progress={100}
      supportsClassification={true}
      supportsProgressBar={true}
      title={data.policyCoverName}
      view={entityView}
      iconUrl={CDN_URL + '/icons/edit-secondary.svg'}
      onClickIcon={handleIconClick}
    ></EntityInfoWidget>
  );
};

export default CoverEntityInfoWidget;
